<template>
    <div>
      <div class="floating-left" style="z-index: 11" v-if="pagesToHide.indexOf(this.$route.name) < 0" @mouseleave="hoverRewardPanel()" @focusout="hideShowRewardPanel()" tabindex="0">
        <div @click="setShowRewardPanel()" @mouseenter="hoverRewardPanel()" class="floating-button">{{ $t(`label.rewards`) }}</div>
        <div v-if="showRewardPanel" class="reward-panel d-flex flex-column justify-center">
          <div class="reward-header d-flex">
            <div><img class="reward-icon" src="/static/svg/gift icons.png" height="53" width="48" alt="reward icon" /></div>
            <div class="text-besidereward"><label>{{ $t(`floating.rewardHeader`) }}</label></div>
            <div @click="hideShowRewardPanel()">
              <v-icon style="color: #fff; right: 1%; position: absolute; font-size: 20px;">mdi-close</v-icon>
            </div>
          </div>
          <div @click="hideShowRewardPanel(); navigateToCoinPage();">
            <img :src="`/static/svg/FloatingReward/Deposit-Rewards-${currentLanguage}.jpg`" class="reward-image" height="63" width="206" alt="deposit get free navigate"/>
            <!--              <v-img class="reward-image" :src="'/static/svg/FloatingReward/Deposit Rewards-${currentLanguage}.jpg'" height="63" width="206" alt="deposit get free navigate"/>-->
          </div>
          <div @click="hideShowRewardPanel(); navigateWOFPage();">
            <!--              <img class="reward-image" :src="`/static/image/layout/${i18n.locale}/FortuneSpin.jpg`" alt="fortune spin navigate"/>-->
            <img class="reward-image" :src="`/static/svg/FloatingReward/Nspin_${currentLanguage}.jpg`" height="63" width="206" alt="fortune spin navigate"/>
          </div>
          <div @click="hideShowRewardPanel(); navigateToDailyCheckIn();">
            <!--                <img class="reward-image" :src="`/static/image/layout/${i18n.locale}/DailyCheckIn.jpg`" alt="daily checkin navigate"/>-->
            <img class="reward-image" :src="`/static/svg/FloatingReward/Check-In-${currentLanguage}.jpg`" height="62" width="206" alt="daily checkin navigate"/>
          </div>
          <div @click="hideShowRewardPanel(); navigateToVoucherPage();">
            <!--              <img class="reward-image" :src="`/static/image/layout/${i18n.locale}/ClaimVoucher.jpg`" alt="claim voucher navigate"/>-->
            <img class="reward-image" :src="`/static/svg/FloatingReward/Claim-Voucher-${currentLanguage}.jpg`" height="62" width="206" alt="claim voucher navigate"/>
          </div>
          <!--          <div @click="hideShowRewardPanel(); navigateToVoucherPage();">-->
          <!--              <img class="reward-image" :src="`/static/svg/FloatingReward/Coin Carnival-${currentLanguage}.jpg`" height="63" width="206"/>-->
          <!--          </div>-->
        </div>
      </div>
      <v-overlay opacity="0.8" z-index="10" :value="showRewardPanel"></v-overlay>
    </div>
</template>

<script>
import {uiHelper, locale} from '@/util'
import i18n from '@/plugins/i18n'
import {ROUTE_NAME} from "@/constants/route.constants";
import {DevicePlatform} from '@/constants/enums'

export default {
  name: 'floatingReward',
  props: {

  },
  data: () => ({
    currentLanguage: uiHelper.getLanguage().toLowerCase(),
    i18n,
    showRewardPanel: false,
    active: false,
    pagesToHide : [ROUTE_NAME.REGISTER , ROUTE_NAME.FUNDS]
  }),
  created() {

  },
  methods: {
    navigateWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          params: { lang: this.$route.params.lang }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          params: { lang: this.$route.params.lang }
        })
      }
    },
    hoverRewardPanel() {
        if(!this.active)
            this.showRewardPanel = !this.showRewardPanel
    },
    setShowRewardPanel() {
        if(!this.active && this.showRewardPanel) {
            this.active = true
            this.showRewardPanel = true
        }
        else {
            this.active = !this.active
            this.showRewardPanel = !this.showRewardPanel
        }
    },
    hideShowRewardPanel() {
        this.active = false
        this.showRewardPanel = false
    },
    navigateToCoinPage() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.FUNDS,
        params:{
          lang: this.$route.params.lang
        }
      })
    },
    navigateToVoucherPage() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.CLAIM_VOUCHER,
        params:{
          lang: this.$route.params.lang
        }
      })
    },
    navigateToDailyCheckIn() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.REWARDS,
        params:{
          lang: this.$route.params.lang
        }
      })
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  }
}
</script>


<style lang="scss">
.text-besidereward {
  width: 120px;
  font-weight: bolder;
  display: flex;
  align-items: center;
  font-size: 19px;
  padding-left: 10px;
}
    .floating-left {
        position: fixed;
        display: flex;
        z-index: 5;
        left: 0;
        top: calc(58% - 106px); //50%

        &:focus {
            &::after {
                width: 100%;
                height: 100%;
                display: absolute;
                z-index: 4;
                background-color: rgba(0, 0, 0, 0.65);
            }
        }

        .disbaled-button {
            pointer-events: none;
            //opacity: 0.4;
        }
        
        .floating-button {
            height: 150px;
            text-align: center;
            background: #8D1CFF 0% 0% no-repeat padding-box;
            color: #ffffff;
            text-transform: uppercase;
            writing-mode: vertical-lr;
            text-orientation: mixed;
            transform: rotate(180deg);
            padding: 4px;
            top: 0;
            cursor: pointer;
        }

        .reward-panel {
            // max-height: 396px;
            // max-width: 212px;
          width: 270px;
            background-color: #000;
            padding: 8px;


            .reward-header {
                color: #fff;
                font-size: 1em;

                .reward-icon {
                    width: 80px;
                    height: 80px;
                    padding: 10px;
                }
            }

            .reward-image {
              width: 100%;
                padding: 0px 0px;
                cursor: pointer;
            }
        }
    }
</style>